"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHILD_QUESTIONS_TYPES = exports.LINK_KEYS = void 0;
var LINK_KEYS = ['countryField', 'regionField'];
exports.LINK_KEYS = LINK_KEYS;
var CHILD_QUESTIONS_TYPES = {
  'country': ['region', 'city'],
  'region': ['city'],
  'city': []
};
exports.CHILD_QUESTIONS_TYPES = CHILD_QUESTIONS_TYPES;